/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { activateInvitedUser } from '../fn/user/activate-invited-user';
import { ActivateInvitedUser$Params } from '../fn/user/activate-invited-user';
import { AgreementsDto } from '../models/agreements-dto';
import { changePassword } from '../fn/user/change-password';
import { ChangePassword$Params } from '../fn/user/change-password';
import { deleteUserById } from '../fn/user/delete-user-by-id';
import { DeleteUserById$Params } from '../fn/user/delete-user-by-id';
import { forgotPassword } from '../fn/user/forgot-password';
import { ForgotPassword$Params } from '../fn/user/forgot-password';
import { forgotPasswordVerify } from '../fn/user/forgot-password-verify';
import { ForgotPasswordVerify$Params } from '../fn/user/forgot-password-verify';
import { getAgreements } from '../fn/user/get-agreements';
import { GetAgreements$Params } from '../fn/user/get-agreements';
import { getAgreementsSigned } from '../fn/user/get-agreements-signed';
import { GetAgreementsSigned$Params } from '../fn/user/get-agreements-signed';
import { getRolesPermissions } from '../fn/user/get-roles-permissions';
import { GetRolesPermissions$Params } from '../fn/user/get-roles-permissions';
import { getUsersByCustomerId } from '../fn/user/get-users-by-customer-id';
import { GetUsersByCustomerId$Params } from '../fn/user/get-users-by-customer-id';
import { inviteUser } from '../fn/user/invite-user';
import { InviteUser$Params } from '../fn/user/invite-user';
import { isUserRegistered } from '../fn/user/is-user-registered';
import { IsUserRegistered$Params } from '../fn/user/is-user-registered';
import { quicksightCreateUser } from '../fn/user/quicksight-create-user';
import { QuicksightCreateUser$Params } from '../fn/user/quicksight-create-user';
import { quicksightDeleteUser } from '../fn/user/quicksight-delete-user';
import { QuicksightDeleteUser$Params } from '../fn/user/quicksight-delete-user';
import { updatePaginationConfig } from '../fn/user/update-pagination-config';
import { UpdatePaginationConfig$Params } from '../fn/user/update-pagination-config';
import { updateUser } from '../fn/user/update-user';
import { UpdateUser$Params } from '../fn/user/update-user';
import { UserResponse } from '../models/user-response';
import { UserRolePermissionDto } from '../models/user-role-permission-dto';

@Injectable({ providedIn: 'root' })
export class UserService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getUsersByCustomerId()` */
  static readonly GetUsersByCustomerIdPath = '/api/user';

  /**
   * Get Users By Customer Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUsersByCustomerId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsersByCustomerId$Response(params: GetUsersByCustomerId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserResponse>>> {
    return getUsersByCustomerId(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Users By Customer Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUsersByCustomerId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsersByCustomerId(params: GetUsersByCustomerId$Params, context?: HttpContext): Observable<Array<UserResponse>> {
    return this.getUsersByCustomerId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserResponse>>): Array<UserResponse> => r.body)
    );
  }

  /** Path part for operation `activateInvitedUser()` */
  static readonly ActivateInvitedUserPath = '/api/user/activate';

  /**
   * Activate Invited User.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `activateInvitedUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  activateInvitedUser$Response(params: ActivateInvitedUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return activateInvitedUser(this.http, this.rootUrl, params, context);
  }

  /**
   * Activate Invited User.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `activateInvitedUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  activateInvitedUser(params: ActivateInvitedUser$Params, context?: HttpContext): Observable<void> {
    return this.activateInvitedUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getAgreements()` */
  static readonly GetAgreementsPath = '/api/user/agreements';

  /**
   * Get Agreements.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAgreements()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAgreements$Response(params?: GetAgreements$Params, context?: HttpContext): Observable<StrictHttpResponse<AgreementsDto>> {
    return getAgreements(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Agreements.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAgreements$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAgreements(params?: GetAgreements$Params, context?: HttpContext): Observable<AgreementsDto> {
    return this.getAgreements$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgreementsDto>): AgreementsDto => r.body)
    );
  }

  /** Path part for operation `getAgreementsSigned()` */
  static readonly GetAgreementsSignedPath = '/api/user/agreements/signed';

  /**
   * Get Agreements Signed.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAgreementsSigned()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAgreementsSigned$Response(params?: GetAgreementsSigned$Params, context?: HttpContext): Observable<StrictHttpResponse<AgreementsDto>> {
    return getAgreementsSigned(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Agreements Signed.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAgreementsSigned$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAgreementsSigned(params?: GetAgreementsSigned$Params, context?: HttpContext): Observable<AgreementsDto> {
    return this.getAgreementsSigned$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgreementsDto>): AgreementsDto => r.body)
    );
  }

  /** Path part for operation `changePassword()` */
  static readonly ChangePasswordPath = '/api/user/changepassword';

  /**
   * Change Password.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `changePassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  changePassword$Response(params: ChangePassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return changePassword(this.http, this.rootUrl, params, context);
  }

  /**
   * Change Password.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `changePassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  changePassword(params: ChangePassword$Params, context?: HttpContext): Observable<void> {
    return this.changePassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `forgotPassword()` */
  static readonly ForgotPasswordPath = '/api/user/forgotpassword';

  /**
   * Forgot Password.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `forgotPassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  forgotPassword$Response(params: ForgotPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return forgotPassword(this.http, this.rootUrl, params, context);
  }

  /**
   * Forgot Password.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `forgotPassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  forgotPassword(params: ForgotPassword$Params, context?: HttpContext): Observable<void> {
    return this.forgotPassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `forgotPasswordVerify()` */
  static readonly ForgotPasswordVerifyPath = '/api/user/forgotpassword/verify';

  /**
   * Forgot Password Verify.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `forgotPasswordVerify()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  forgotPasswordVerify$Response(params: ForgotPasswordVerify$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return forgotPasswordVerify(this.http, this.rootUrl, params, context);
  }

  /**
   * Forgot Password Verify.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `forgotPasswordVerify$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  forgotPasswordVerify(params: ForgotPasswordVerify$Params, context?: HttpContext): Observable<void> {
    return this.forgotPasswordVerify$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `inviteUser()` */
  static readonly InviteUserPath = '/api/user/invite';

  /**
   * Invite User.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inviteUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inviteUser$Response(params: InviteUser$Params, context?: HttpContext): Observable<StrictHttpResponse<UserResponse>> {
    return inviteUser(this.http, this.rootUrl, params, context);
  }

  /**
   * Invite User.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inviteUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inviteUser(params: InviteUser$Params, context?: HttpContext): Observable<UserResponse> {
    return this.inviteUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserResponse>): UserResponse => r.body)
    );
  }

  /** Path part for operation `quicksightCreateUser()` */
  static readonly QuicksightCreateUserPath = '/api/user/quicksight/{email}';

  /**
   * Quicksight Create User.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `quicksightCreateUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  quicksightCreateUser$Response(params: QuicksightCreateUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return quicksightCreateUser(this.http, this.rootUrl, params, context);
  }

  /**
   * Quicksight Create User.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `quicksightCreateUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  quicksightCreateUser(params: QuicksightCreateUser$Params, context?: HttpContext): Observable<void> {
    return this.quicksightCreateUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `quicksightDeleteUser()` */
  static readonly QuicksightDeleteUserPath = '/api/user/quicksight/{email}';

  /**
   * Quicksight Delete User.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `quicksightDeleteUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  quicksightDeleteUser$Response(params: QuicksightDeleteUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return quicksightDeleteUser(this.http, this.rootUrl, params, context);
  }

  /**
   * Quicksight Delete User.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `quicksightDeleteUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  quicksightDeleteUser(params: QuicksightDeleteUser$Params, context?: HttpContext): Observable<void> {
    return this.quicksightDeleteUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `isUserRegistered()` */
  static readonly IsUserRegisteredPath = '/api/user/quicksight/{email}/existed';

  /**
   * Is User Registered.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `isUserRegistered()` instead.
   *
   * This method doesn't expect any request body.
   */
  isUserRegistered$Response(params: IsUserRegistered$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return isUserRegistered(this.http, this.rootUrl, params, context);
  }

  /**
   * Is User Registered.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `isUserRegistered$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  isUserRegistered(params: IsUserRegistered$Params, context?: HttpContext): Observable<boolean> {
    return this.isUserRegistered$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `getRolesPermissions()` */
  static readonly GetRolesPermissionsPath = '/api/user/roles';

  /**
   * Get Roles Permissions.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRolesPermissions()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRolesPermissions$Response(params?: GetRolesPermissions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserRolePermissionDto>>> {
    return getRolesPermissions(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Roles Permissions.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRolesPermissions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRolesPermissions(params?: GetRolesPermissions$Params, context?: HttpContext): Observable<Array<UserRolePermissionDto>> {
    return this.getRolesPermissions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserRolePermissionDto>>): Array<UserRolePermissionDto> => r.body)
    );
  }

  /** Path part for operation `updateUser()` */
  static readonly UpdateUserPath = '/api/user/{userId}';

  /**
   * Update User.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUser$Response(params: UpdateUser$Params, context?: HttpContext): Observable<StrictHttpResponse<UserResponse>> {
    return updateUser(this.http, this.rootUrl, params, context);
  }

  /**
   * Update User.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUser(params: UpdateUser$Params, context?: HttpContext): Observable<UserResponse> {
    return this.updateUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserResponse>): UserResponse => r.body)
    );
  }

  /** Path part for operation `deleteUserById()` */
  static readonly DeleteUserByIdPath = '/api/user/{userId}';

  /**
   * Delete User By Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteUserById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUserById$Response(params: DeleteUserById$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteUserById(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete User By Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteUserById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUserById(params: DeleteUserById$Params, context?: HttpContext): Observable<void> {
    return this.deleteUserById$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updatePaginationConfig()` */
  static readonly UpdatePaginationConfigPath = '/api/user/{userId}/config/pagination';

  /**
   * Update Pagination Config.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePaginationConfig()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePaginationConfig$Response(params: UpdatePaginationConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<UserResponse>> {
    return updatePaginationConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Pagination Config.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePaginationConfig$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePaginationConfig(params: UpdatePaginationConfig$Params, context?: HttpContext): Observable<UserResponse> {
    return this.updatePaginationConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserResponse>): UserResponse => r.body)
    );
  }

}
